import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Menu, Dropdown, Avatar } from 'antd';
import 'antd/dist/antd.css';
import { USER_LOGOUT } from '../state/token/types';
import PropTypes from 'prop-types';

/**
 * Component that returns a menu button.
 * @component
 * @returns {Element} Button with user options
 */
function MenuButton({ logout, user }) {

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) { return; }
    setOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  /**
   * Function that return a acronim of user name.
   * @returns {String} Acronim of user name
   */
  const userAcronimName = `${user.first_name?.charAt(0)}${user.last_name?.charAt(0)}`;

  const menu = (
    <Menu>
      <Menu.Item>
        <NavLink to="/account/profile">
          Mi cuenta
        </NavLink>
      </Menu.Item>
      <Menu.Item onClick={(event) => {
        handleClose(event);
        logout();
      }}>
        Cerrar Sesión
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
        <Avatar>
          {userAcronimName}
        </Avatar>
      </a>
    </Dropdown>
  );
}

MenuButton.propTypes = {
  /**
   * Function that dispatch logout action
   */
  logout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const data = state => ({
  user: state.user.user,
});

const actions = dispatch => ({
  logout: () => dispatch({ type: USER_LOGOUT }),
});

export default connect(data, actions)(MenuButton);